import axios from 'axios';
import notifiers from '@/utils/notifiers';

const csrfToken = document.head.querySelector('meta[name="csrf-token"]');

const client = axios.create({ baseURL: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/api/app-v1` });

export default {

    async execute(method, url, data = null) {
        return client({
            method,
            url,
            data,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': csrfToken.content,
            },
        })
            .then(request => request.data)
            .catch((error) => {
                if (!error.response) {
                    notifiers.error('Please check your connection.');
                } else {
                    notifiers.error('Please try again.');
                }
                return Promise.reject(error.response.data.errors);
            });
    },

    async createAccount(account) {
        const data = {
            address: account.address,
            address_line_2: account.addressLine2,
            address_line_3: account.addressLine3,
            city: account.city,
            country: account.country,
            facebook: account.facebook,
            fax: account.fax,
            invoice_address: account.invoice.address,
            invoice_city: account.invoice.city,
            invoice_country: account.invoice.country,
            invoice_postcode: account.invoice.postcode,
            invoice_region: account.invoice.region,
            is_agent: account.isAgent,
            is_client: account.isClient,
            is_supplier: account.isSupplier,
            is_venue: account.isVenue,
            linkedin: account.linkedIn,
            name: account.name,
            phone: account.phone,
            postcode: account.postcode,
            region: account.region,
            industry_type_id: account.industryType.id,
            website: account.website,
            types: account.types,
            teams: account.teams,
            source_id: account.source.id,
        };
        return this.execute('post', 'accounts', { data });
    },

};
